"use client"
import { PortfolioStaticDataQuery, PortfolioStaticFiltersDocument, PortfolioStaticFiltersQuery } from "@/gql/graphql"

import { useQuery } from "@apollo/client"
import { useEffect, useState } from "react"
import { PortfolioUIState } from "../../page"
import { ProjectFiltersDesktop } from "./ProjectFiltersDesktop"
import { ProjectFiltersMobile } from "./ProjectFiltersMobile"

interface Props {
  staticData: PortfolioStaticDataQuery
  uiState: PortfolioUIState
}

export function FilterLoader({ staticData, uiState }: Props) {
  const [filters, setFilters] = useState<PortfolioStaticFiltersQuery | null>(null)
  const [filtersLoading, setFiltersLoading] = useState(false)
  useEffect(() => {
    if (uiState.isAuthenticated) return
    const fetchPortfolioFilters = async () => {
      setFiltersLoading(true)
      const res = await fetch(`/api/filters/portfolio-filters/${staticData.creativeByHandle.id}`)
      const data: { data: PortfolioStaticFiltersQuery | null } = await res.json()
      setFilters(data?.data)
      setFiltersLoading(false)
    }
    fetchPortfolioFilters()
  }, [staticData.creativeByHandle.id, uiState.isAuthenticated])

  const { data: authenticatedData, loading: authenticatedLoading } = useQuery(PortfolioStaticFiltersDocument, {
    variables: {
      id: staticData.creativeByHandle.id,
    },
    skip: !uiState.isAuthenticated,
  })

  return (
    <>
      <div className="hidden sm:flex">
        <ProjectFiltersDesktop
          staticData={staticData}
          filtersData={authenticatedData || filters}
          filtersLoading={authenticatedLoading || filtersLoading}
        />
      </div>
      <div className="sm:hidden">
        <ProjectFiltersMobile
          staticData={staticData}
          filtersData={authenticatedData || filters}
          filtersLoading={authenticatedLoading || filtersLoading}
        />
      </div>
    </>
  )
}
